/*
 * @Author: Admni
 * @Description: 
 * @Date: 2020-12-24 16:46:24
 * @LastEditTime: 2020-12-29 13:40:51
 */
module.exports = {

  title: '客服平台',
  fixedHeader: false,
  sidebarLogo: false
}
